import Common from './_Common';

export default Common('properties', 'properties');
